// ページ設定関連の定数
export const PAGE_CONFIG = {
  // グリッド設定
  MAX_COLUMNS: 10,
  MIN_ROWS: 1,
  MAX_ROWS: 20,
  
  // スライド設定
  MIN_SLIDE_WIDTH: 10,
  MAX_SLIDE_WIDTH: 100,
  DEFAULT_SLIDE_WIDTH: 100,
  
  // ファイル制限
  MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'] as const,
  
  // UI設定
  CARD_WIDTH: 168,
  CARD_HEIGHT: 292, // 168 * (1740 / 1000) = 292.32 ≈ 292 (フロント側と同じ比率 1000:1740)
  ASPECT_RATIO: 1000/1740,
} as const;

// ラベル・メッセージ
export const PAGE_MESSAGES = {
  // エラーメッセージ
  FILE_SIZE_ERROR: 'ファイルサイズが大きすぎます。100MB以下のファイルを選択してください。',
  IMAGE_TYPE_ERROR: '画像ファイルを選択してください。',
  SITE_ID_ERROR: 'サイトIDが見つかりません。ページをリロードしてください。',
  
  // 確認メッセージ
  DELETE_PAGE_CONFIRM: (pageName: string) => `${pageName} を削除しますか？`,
  DELETE_SLIDE_CONFIRM: (slideName: string) => `${slideName} を削除しますか？`,
  FORCE_APPLY_CONFIRM: '列数を減らすと、既存のスライドが削除されます。続行しますか？',
  
  // ヘルパーテキスト
  GRID_SIZE_HELP: '1列固定で、最大10列まで設定可能です。列を増やすことで、より多くの横スライドを配置できます。',
  SLIDE_WIDTH_HELP: 'スライドの横幅を設定できます（10%～100%）。100%未満の場合、中央に配置され左右のスライドも表示されます。例: 33%の場合、左右のスライドも見えるカルーセル形式になります。',
  POSITION_ADJUST_HELP: '例: 40（下に40px移動）、-20（上に20px移動）',
  INITIAL_SLIDE_HELP: 'ダイアログを開いたときの最初に表示するスライドを設定します。',
  INDICATOR_POSITION_HELP: 'ナビゲーションドットの表示位置を選択できます。画像の上または下に配置されます。',
  LOOP_SETTING_HELP: '横スライドの動作を設定します。無限ループを有効にすると、最後のスライドから最初のスライドに自動的に戻ります。',
} as const;

// フォーム設定
export const FORM_CONFIG = {
  POSITION_ADJUSTMENT: {
    PLACEHOLDER: '0',
    WIDTH: 200,
  },
  SLIDE_WIDTH: {
    WIDTH: 80,
    MIN: 10,
    MAX: 100,
    STEP: 1,
  },
  COLUMNS: {
    WIDTH: 80,
    MIN: 1,
    MAX: 10,
  },
  INITIAL_INDEX: {
    WIDTH: 120,
  },
  INDICATOR_POSITION: {
    WIDTH: 150,
  },
} as const;

// 列番号を文字に変換する関数
export const getColumnLetter = (columnNumber: number): string => {
  const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  
  if (columnNumber <= 26) {
    return letters[columnNumber - 1];
  }
  
  // 27列目以降は、AA, AB, AC...のようにする
  const adjustedNumber = columnNumber - 26;
  const firstLetter = Math.floor((adjustedNumber - 1) / 26);
  const secondLetter = (adjustedNumber - 1) % 26;
  return letters[firstLetter] + letters[secondLetter];
};
